import {trans} from '@frontend/helpers'
import {AdLikeIconButton} from '@frontend/modules/public/ads/components/list/AdLikeIconButton'
import {mdiPercent} from '@mdi/js'
import {Icon} from 'swayok-react-mdb-ui-kit/components/Icon/Icon'
import type {
    AdPreviewDataForGrid,
    AdPreviewDataForList,
} from '../../AdsModuleTypes'

interface Props {
    ad: AdPreviewDataForList | AdPreviewDataForGrid
    discounted?: boolean
    liked?: boolean
    disabled?: boolean
}

// Иконки для карточки объявления (лайк, скидка и т.п.).
export function AdsListItemIcons(props: Props) {

    const {
        ad,
        discounted,
        liked = false,
        disabled,
    } = props

    return (
        <div className="offered-item-card-icons d-flex flex-column align-items-center justify-content-center">
            <AdLikeIconButton
                ad={ad}
                isFavourite={liked}
                noLabel
                white
                filled
                disabled={disabled}
                className="offered-item-card-icon btn-like p-1"
            />
            {discounted && (
                <Icon
                    path={mdiPercent}
                    tooltip={trans().ads.has_discount}
                    tooltipToggleTag="div"
                    tooltipToggleClassName="mt-2 offered-item-card-icon icon-discount flex-center"
                    color="white"
                    size={14}
                />
            )}
        </div>
    )
}
